import * as PropTypes from 'prop-types';
import * as React from 'react';
import Tooltip from '../../../../tooltip';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import * as classNames from 'classnames';

class BulkCuratedSetItem extends React.Component {
  static get propTypes() {
    return {
      curatedSet: PropTypes.object.isRequired,
    };
  }

  constructor() {
    super();

    this.state = {
      addingListings: false,
      addedListings: false,
      removingListings: false,
      removedListings: false,
      error: false,
    };

    this.handleAddListings = this.handleAddListings.bind(this);
    this.handleRemoveListings = this.handleRemoveListings.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  get curatedSet() {
    return this.props.curatedSet;
  }

  get canAdd() {
    return !this.curatedSet.unavailable_to_add_reason;
  }

  handleAddListings(e) {
    e.preventDefault();

    this.setState({ addingListings: true });

    APIRequest.V3.post(`/my/selling/curated_sets/${this.curatedSet.id}/add_listings${window.location.search}`).then(() => {
      this.setState({
        addingListings: false,
        addedListings: true,
      });
    }).fail(this.handleError);
  }

  handleRemoveListings(e) {
    e.preventDefault();

    this.setState({ removingListings: true });

    APIRequest.V3.post(`/my/selling/curated_sets/${this.curatedSet.id}/remove_listings${window.location.search}`).then(() => {
      this.setState({
        removingListings: false,
        removedListings: true,
      });
    }).fail(this.handleError);
  }

  handleError() {
    this.setState({
      error: true,
      addingListings: false,
      removingListings: false,
    });
  }

  renderLabelTooltip() {
    if (!this.curatedSet.label_tooltip) { return null; }

    return (
      <Tooltip
        title={this.curatedSet.label_tooltip}
        className="ml-half"
      />
    );
  }

  renderTitleLabel() {
    if (!this.curatedSet.label) { return null; }

    const classes = classNames(
      'weight-bold',
      { 'color-orange': !this.curatedSet.lp_only },
      { 'color-blue': this.curatedSet.lp_only },
    );

    return (
      <div className={classes} data-title-label>
        {this.curatedSet.label}
        {this.renderLabelTooltip()}
      </div>
    );
  }

  renderTitle() {
    return (
      <a
        href={this.curatedSet._links.self.href}
        className="d-block weight-bold"
        target="_blank"
      >
        {this.curatedSet.name}
      </a>
    );
  }

  renderAddButton() {
    const disabled = !this.canAdd;
    const classes = classNames(
      'button button--mini mr-half',
      {
        'button--orange': !this.curatedSet.lp_only,
        'button--blue': this.curatedSet.lp_only,
      },
    );

    if (disabled) {
      return (
        <span
          className={classes}
          data-disabled
        >
          {I18n.t('js.dashboard.selling.bulkSale.addDisabled')}
        </span>
      );
    }

    const count = this.curatedSet.add_count;
    if (count < 1) { return null; }
    const i18nKey = this.curatedSet.used_only ? 'addUsedListings' : 'addListings';
    return (
      <button
        onClick={this.handleAddListings}
        className={classes}
        data-add-button
      >
        {this.renderI18nCount(i18nKey, count)}
      </button>
    );
  }

  renderRemoveButton() {
    const count = this.curatedSet.remove_count;
    if (count < 1) { return null; }

    return (
      <button
        href="#"
        onClick={this.handleRemoveListings}
        className="button button--mini mr-space"
        data-remove-button
      >
        {this.renderI18nCount('removeListings', count)}
      </button>
    );
  }

  renderI18nCount(i18nKey, count) {
    return I18n.t(`js.dashboard.selling.bulkSale.${i18nKey}`, {
      formattedCount: I18n.toNumber(count),
      count,
    });
  }

  renderSuccess(i18nKey, count) {
    return (
      <div className="color-green icon-l-check">
        {this.renderI18nCount(i18nKey, count)}
      </div>
    );
  }

  renderUnavailableMessage() {
    if (this.canAdd) return null;

    return (
      <p className="color-red weight-bold">
        {this.curatedSet.unavailable_to_add_reason}
      </p>
    );
  }

  renderUsedOnlyHint() {
    if (!this.curatedSet.used_only) { return null; }
    const tooltipText = I18n.t('js.dashboard.selling.bulkSale.usedOnlyTooltip', {
      linkStart: '<a class=\'color-orange\' href=\'/page/preferred-seller-program\' target=_blank>',
      linkEnd: '</a>',
    });

    return (
      <div>
        {I18n.t('js.dashboard.selling.bulkSale.usedOnlyHint')}
        <Tooltip
          title={tooltipText}
          className="ml-half"
        />
      </div>
    );
  }

  renderActions() {
    if (this.state.addedListings) {
      return this.renderSuccess('listingsAdded', this.curatedSet.add_count);
    } else if (this.state.removedListings) {
      return this.renderSuccess('listingsRemoved', this.curatedSet.remove_count);
    } else if (this.state.addingListings || this.state.removingListings) {
      return (
        <div className="weight-bold opacity-60">
          {I18n.t('js.wait')}
        </div>
      );
    } else if (this.state.error) {
      return (
        <div className="alert alert-error alert-small">
          {I18n.t('js.dashboard.selling.bulkSale.error')}
        </div>
      );
    }

    return (
      <div>
        {this.renderAddButton()}
        {this.renderRemoveButton()}
      </div>
    );
  }

  render() {
    return (
      <div className="mtb-1 bd-1 bd--offwhite scaling-padding-1 size-90">
        {this.renderTitleLabel()}
        {this.renderTitle()}
        {this.curatedSet.additional_information}
        <div className="size-90 mtb-half">
          {this.curatedSet.summary}
        </div>
        {this.renderUnavailableMessage()}
        {this.renderActions()}
        {this.renderUsedOnlyHint()}
      </div>
    );
  }
}
export default BulkCuratedSetItem;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/listings_manager/sales/bulk_curated_set_item.jsx